<div class="thinking-bubble" role="status" [attr.aria-label]="message()">
    <span class="thinking-dots">
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
    </span>
    <span class="thinking-text">{{ message() }}</span>
</div>
